// Standalone /diagnostics route (IM-2465). Kept as the fallback for when the app
// itself will not load (a modal cannot help then); the same panel body is shared
// with the footer pop-up modal via DiagnosticsPanel.
import DiagnosticsPanel from './diagnostics-panel';

const Diagnostics = () => <DiagnosticsPanel variant="page" />;

export default Diagnostics;
